module.exports = __webpack_public_path__ + "img/card2.png?ea8aadf460128b37d41b9cd9b06cfc6f";